/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_Minutes_LabelInputs */

const en_subtitle_export_minutes_label = /** @type {(inputs: Subtitle_Export_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutes`)
};

const fr_subtitle_export_minutes_label = /** @type {(inputs: Subtitle_Export_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutes`)
};

const de_subtitle_export_minutes_label = /** @type {(inputs: Subtitle_Export_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuten`)
};

const it_subtitle_export_minutes_label = /** @type {(inputs: Subtitle_Export_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minuti`)
};

const ru_subtitle_export_minutes_label = /** @type {(inputs: Subtitle_Export_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Протокол`)
};

const es_subtitle_export_minutes_label = /** @type {(inputs: Subtitle_Export_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutos`)
};

const zh_cn2_subtitle_export_minutes_label = /** @type {(inputs: Subtitle_Export_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分钟`)
};

const ja_subtitle_export_minutes_label = /** @type {(inputs: Subtitle_Export_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分`)
};

const hi_subtitle_export_minutes_label = /** @type {(inputs: Subtitle_Export_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मिनट`)
};

const pt_pt2_subtitle_export_minutes_label = /** @type {(inputs: Subtitle_Export_Minutes_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minutos`)
};

/**
* | output |
* | --- |
* | "Minutes" |
*
* @param {Subtitle_Export_Minutes_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_minutes_label = /** @type {((inputs?: Subtitle_Export_Minutes_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_Minutes_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_minutes_label(inputs)
	if (locale === "de") return de_subtitle_export_minutes_label(inputs)
	if (locale === "it") return it_subtitle_export_minutes_label(inputs)
	if (locale === "ru") return ru_subtitle_export_minutes_label(inputs)
	if (locale === "es") return es_subtitle_export_minutes_label(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_minutes_label(inputs)
	if (locale === "ja") return ja_subtitle_export_minutes_label(inputs)
	if (locale === "hi") return hi_subtitle_export_minutes_label(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_minutes_label(inputs)
	return en_subtitle_export_minutes_label(inputs)
});